import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["results", "searchInput", "modal"]
  static values = {
    url: String,
    type: { type: String, default: "" }
  }

  connect() {
    this.selectedCallback = null
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    this.searchInputTarget.focus()
    this.search()
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
    this.searchInputTarget.value = ""
  }

  async search() {
    const query = this.searchInputTarget.value
    const params = new URLSearchParams()
    if (query) params.set("q", query)
    if (this.typeValue) params.set("type", this.typeValue)

    try {
      const response = await fetch(`${this.urlValue}?${params}`)
      const assets = await response.json()
      this.renderResults(assets)
    } catch (error) {
      this.resultsTarget.innerHTML = '<p class="text-sm text-red-500 p-4">Failed to load assets.</p>'
    }
  }

  renderResults(assets) {
    if (assets.length === 0) {
      this.resultsTarget.innerHTML = '<p class="text-sm text-gray-400 p-4 text-center">No matching assets found.</p>'
      return
    }

    this.resultsTarget.innerHTML = assets.map(asset => `
      <div class="flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg cursor-pointer border-b last:border-0"
           data-action="click->audio-library-picker#select"
           data-asset-id="${asset.id}"
           data-asset-url="${asset.url}"
           data-asset-label="${asset.label}">
        <div class="flex-shrink-0">
          <i class="fas ${this.iconForType(asset.asset_type)} ${this.colorForType(asset.asset_type)}"></i>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-800 truncate">${asset.label}</p>
          <p class="text-xs text-gray-400">
            ${asset.source} &middot; ${asset.duration_seconds ? asset.duration_seconds.toFixed(1) + 's' : ''}
            ${asset.favorited ? '<i class="fas fa-star text-yellow-400 ml-1"></i>' : ''}
          </p>
        </div>
        <audio controls preload="none" class="h-7 w-32 flex-shrink-0" onclick="event.stopPropagation()">
          <source src="${asset.url}" type="audio/mpeg">
        </audio>
        <button class="text-xs text-indigo-600 hover:text-indigo-800 font-medium flex-shrink-0">Select</button>
      </div>
    `).join("")
  }

  select(event) {
    const target = event.currentTarget
    const url = target.dataset.assetUrl
    const id = target.dataset.assetId

    this.dispatch("selected", { detail: { url, id } })
    this.close()
  }

  iconForType(type) {
    const icons = { voiceover: "fa-microphone", music: "fa-music", sfx: "fa-volume-up" }
    return icons[type] || "fa-file-audio"
  }

  colorForType(type) {
    const colors = { voiceover: "text-indigo-500", music: "text-green-500", sfx: "text-amber-500" }
    return colors[type] || "text-gray-500"
  }
}
